/**
 * Created by JasonChou on 17/6/14.
 */

///views
import './layouts/layouts.css'
export const Avatar = require('./Avatar').default;
export const Text = require('./Text').default;
export const Button = require('./Button').default;
// export const P = require('./P').default;
// export const FeedUserHeader = require('./FeedUserHeader').default;
// export const Toast = require('./toast/Toast').default;
export const NetImage = require('./NetImage').default;
export const Image = require('./Image').default;
export const Input = require('./Input').default;
export const CaptchaBtn = require('./CaptchaBtn').default;

///layouts
export const Horizontal = require('./layouts/Horizontal').default;
export const Vertical = require('./layouts/Vertical').default;
export const Grid = require('./layouts/Grid').default;
export const GridColumn = require('./layouts/GridColumn').default;

//base
export const ListScreen = require('./list_screen/ListScreen').default;


// WEBPACK FOOTER //
// ./src/components/index.js